import "./style.css";
import { SideBarData } from "./SidebarData";
import { Icon } from "semantic-ui-react";
import { useHistory } from "react-router";
import { useState } from "react";

const SideBar = () => {
  const history = useHistory();

  const [selected, setSelected] = useState(SideBarData[0].title);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const handleClickMenu = (val) => {
    setSelected(val.title);
    history.push(val.link);
  };

  return (
    <div className={`Sidebar ${isSidebarOpen ? "SidebarOpen" : ""}`}>
      <div className="SidebarHeader">
        <h4>Menú</h4>
      </div>

      <ul className="SidebarList">
        {SideBarData.map((val, index) => {
          const itemSelected = selected === val.title;
          const hasSubmenus = !!val.subMenuItems.length;

          return (
            // <>
              <li
                className="row"
                key={`Menu-${index}`}
                id={itemSelected ? "active" : ""}
                onClick={() => handleClickMenu(val)}
              >
                {isSidebarOpen && <div id={itemSelected ? "margin" : "noMargin"}></div>}
                <div id="icon">
                  <Icon name={val.icon} />
                </div>
                {isSidebarOpen && <div id="title">{val.title}</div>}
                {hasSubmenus && (
                  <div id="DropDownIcon">
                    {" "}
                    <Icon name="dropdown" />
                  </div>
                )}
              </li>
              /*{hasSubmenus && (
                <ul>
                  {val.subMenuItems.map((valSM, index) => {
                    return (
                      <li key={`SMenu-${index}`} className="row rowSubMenu">
                        {valSM.title}
                      </li>
                    );
                  })}
                </ul>
              )} */
            /* </> */
          );
        })}
      </ul>

      <div className="TogglerContainer">
        <div
          className="Toggler"
          onClick={() => {
            setIsSidebarOpen(!isSidebarOpen);
          }}
        >
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
